import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'elements';

import styles from './linkItem.scss';

const LinkItem = ({ href, children, isOwner, link, onClick }) => (
  <div className={styles.linkItem}>
    <a href={href} className={styles.text} target="_blank">
      {children}
    </a>
    {isOwner &&
      <div onClick={() => onClick(link)}>
        <Icon className={styles.linkEdit} name="icon-edit" />
      </div>
    }
  </div>
);

LinkItem.proptypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  href: PropTypes.string.isRequired,
  link: PropTypes.object,
  onClick: PropTypes.func,
  isOwner: PropTypes.bool,
};

export { LinkItem };



// WEBPACK FOOTER //
// ./src/elements/linkItem/linkItem.js